"use client";
import React, { useState, useEffect } from "react";
import { usePathname } from "next/navigation";
import "./WhatsAppButton.scss";
import { Image } from "antd";
import whatsAppLogo from "../../assets/images/looking to buy.png";
import WhatsAppForm from "./WhatsAppForm/WhatsAppForm";

const WhatsAppButton = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const pathname = usePathname();

  const shouldHideButton =
    pathname.includes("/11-11") ||
    pathname.includes("/cart") ||
    pathname.includes("/checkout") ||
    pathname.includes("/b2b-payments");

  const toggleForm = () => {
    setIsFormOpen(!isFormOpen);
    // When opening the form, prevent body scrolling
    if (!isFormOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  };

  // If button should be hidden, don't render anything
  if (shouldHideButton) {
    return null;
  }

  return (
    <>
      <div className="whatsapp-widget">
        <button
          className="whatsapp-button"
          onClick={toggleForm}
          aria-label="Open installment form"
        >
          <Image
            preview={false}
            src={whatsAppLogo.src}
            alt="Installment Plan"
            className="whatsapp-gif"
          />
        </button>
      </div>

      {isFormOpen && (
        <div className="whatsapp-form-overlay" onClick={toggleForm}>
          <div
            className="whatsapp-form-container open"
            onClick={(e) => e.stopPropagation()}
          >
            <WhatsAppForm onClose={toggleForm} />
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;
